module.exports = __webpack_public_path__ + "static/media/logo.c4ec3c8f.png";